export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9141.80321d01.jpg";